export const projects = [
  {
    id: 1,
    titleKey: "projectData.0.title",
    descriptionKey: "projectData.0.description",
    image: "/images/projects/podana.png",
    tags: ["React", "Vite", "Tailwind3.4", "Firebase", "SwiftUI", "Kotlin", "Node.js", "Stripe", "AdMob"],
    links: {
      website: "https://podana.net",
      appstore: "https://apps.apple.com/us/app/podana-podiatry-anamnesis/id6467253982",
      playstore: "https://play.google.com/store/apps/details?id=net.podana.mobile",
    },
    featured: true
  },
  {
    id: 2,
    titleKey: "projectData.1.title",
    descriptionKey: "projectData.1.description",
    image: "/images/projects/migopet.png",
    tags: ["SwiftUI", "Kotlin", "Firebase", "Node.js", "RevenueCat", "AdMob"],
    links: {
      //website: "https://migopet.com",
      appstore: "https://apps.apple.com/us/app/migopet/id6815879002",
      playstore: "https://play.google.com/store/apps/details?id=net.migopet.mobile",
    }
  },
  {
    id: 3,
    titleKey: "projectData.2.title",
    descriptionKey: "projectData.2.description",
    image: "/images/projects/meunovohabito.png",
    tags: ["ReactJS", "Firebase", "SwiftUI", "Kotlin", "Node.js"],
    links: {
      //website: "https://podana.net",
      appstore: "https://apps.apple.com/us/app/meu-novo-hábito/id6469234776",
      playstore: "https://play.google.com/store/apps/details?id=net.meunovohabito.mobile",
    }
  },
  {
    id: 4,
    titleKey: "projectData.3.title",
    descriptionKey: "projectData.3.description",
    image: "/images/projects/mathsprintchallenge.png",
    tags: ["Firebase", "SwiftUI", "Kotlin", "AdMob"],
    links: {
      //website: "https://podana.net",
      appstore: "https://apps.apple.com/us/app/math-sprint-challenge/id6758415290",
      playstore: "https://play.google.com/store/apps/details?id=com.hsinhori.mathsprintchallenge",
    }
  },
];